import { render, staticRenderFns } from "./culturalNewsdetail.vue?vue&type=template&id=567e5e52&scoped=true&"
import script from "./culturalNewsdetail.vue?vue&type=script&lang=js&"
export * from "./culturalNewsdetail.vue?vue&type=script&lang=js&"
import style0 from "./culturalNewsdetail.vue?vue&type=style&index=0&id=567e5e52&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567e5e52",
  null
  
)

component.options.__file = "culturalNewsdetail.vue"
export default component.exports